<template>
    <div>
        <navigation-bar Back/>
        <div class="main pb-4">

            <div class="list-style2">
                <img src="../../assets/images/table-order-phone.svg" class="mr-2 fixed-w-20" v-show="!isTableOrderAddItem">
                <div class="flex-grow-1">{{isTableOrderAddItem ? orderSnSubstring : countryCodeName + dataObject.phone}}</div>
                <div>共 {{recordList.length}} 筆記錄</div>
            </div>
            <div class="no-data" v-if="recordList.length === 0">
              <img src="@/assets/images/empty.svg">
              <p>OH！目前空空的</p>
            </div>

            <div v-for="(item, index) in recordList" :key="index" class="list-style2">
                <h2 class="w-100 yellow">{{isTableOrderAddItem ? item.orderSn : "#"+item.takeoutSerialNumber}}</h2>
                <div class="content">
                    <div class="d-flex">
                        <div class="add flex-grow-1">
                            {{ isTableOrderAddItem ? "建單" : "點餐"}}時間 {{item.workedAt}}<br>
                            {{item.adult}}位大人 {{item.child}}位小孩<br>
                            桌號 {{item.tableNo}}<br>
                            付款方式 : {{item.payment.length > 0 ? `${item.payment[0].name}${$public.notNull(item.payment[0].cardNumber)&& item.payment[0].cardNumber !== "" ? ` (${item.payment[0].cardNumber})` : ""}` : "現金"}}
                        </div>
                        <div class="right">
                            <p class="type red" v-if="!item.isCheckout && item.orderStatus === 1">待付款</p>
                            <p class="type green" v-else-if="item.isCheckout && item.orderStatus === 1">已結帳</p>
                            <p class="type" v-else-if="item.orderStatus === 2 || item.orderStatus === 3">{{ !item.isCheckout ? "已取消" : "已退款" }}</p>
                        </div>
                    </div>
                </div>

                <div class="top-cart-list">
                    <div class="input-group mt-2">
                        <div class="name">
                            {{item.amount}}份餐點
                        </div>
                        <div class="fee red">
                            $ {{item.invoicePrice}}
                        </div>
                    </div>
                </div>
                <div class="red" v-if="item.takeoutStatus === 4">
                    {{item.isUserCancel ? "會員取消：" : "店家取消："}}{{item.cancelReason}}
                </div>
                <div class="button-list">
                    <el-button round @click="goDetail(item)">查看明細</el-button>
                </div>
            </div>

            <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>
    </div>

</template>

<script>

  import * as constDefine from "@/store/constDefine";
    export default {
        name: "TableOrderRecord",
        data() {
            return {
                isLoading: false,
                dataObject: {},
                recordList: [],
                isTableOrderAddItem: false,
                orderId: 0,
                orderSnSubstring: "",
                countryCodeName: '',
            }
        },
        created() {
          try {
            this.dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
            this.countryCodeName = this.dataObject.countryCodeData !== undefined && this.dataObject.countryCodeData.code !== "+886" ? this.dataObject.countryCodeData.enName + this.dataObject.countryCodeData.code + " " : "";
              if (this.dataObject.usedType === constDefine.QRCodeUsedType.TableOrderAddItem) {
                  this.isTableOrderAddItem = true
                  this.orderId = this.dataObject.orderId
                  this.setupDataFromOrderId();
              } else {
                  this.setupData();
              }
          } catch (e) {
            this.$router.push({name:'Error'});
            return false;
          }
        },
        mounted() {

        },
        methods: {
          setupData() {
            this.isLoading = true
            this.$http.fetch`GetTableOrderList${{
              storeId:    this.dataObject.storeId,
              phone:      this.dataObject.phone,
              countryCode:      this.dataObject.countryCodeData.code,
              countryName:      this.dataObject.countryCodeData.enName,
            }}
          ${json => {
              if (json.status) {
                this.recordList = json.data;
              } else {
                this.$public.showNotify(json.message, json.status);
              }
              this.isLoading = false
            }}`;
          },
            setupDataFromOrderId() {
                this.isLoading = true
                this.$http.fetch`GetQRCodeOrderList${{
                    orderId:      this.orderId,
                    storeId:      this.dataObject.storeId,
                }}
              ${json => {
                    if (json.status) {
                        this.orderSnSubstring = json.data.orderSnSubstring;
                        this.recordList = json.data.dataList;
                    } else {
                        this.$public.showNotify(json.message, json.status);
                    }
                    this.isLoading = false
                }}`;
            },
          goDetail(item) {
              if(this.isTableOrderAddItem) {
                  let dataObject = this.dataObject
                  let dataToken = this.$crypto.objectToURIComponent({
                      "orderId":          item.id,
                      "storeId":          item.storeId,
                      "usedType":         dataObject.usedType,
                      "prototypeObject":  {...dataObject.prototypeObject},
                  })
                  this.$router.push({path: dataObject.tableOrderRoutePath + "/complete", query: {dataToken: dataToken}});
              } else {
                  this.dataObject = {...this.dataObject, ...{
                          "takeoutId":  item.id,
                      }}
                  sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(this.dataObject));

                  let dataToken = this.$crypto.objectToURIComponent({
                      "takeoutId":        item.id,
                      "storeId":          this.dataObject.storeId,
                      "prototypeObject":  {...this.dataObject.prototypeObject},
                  })

                  if(this.dataObject.routePath) {
                      this.$router.push({path: this.dataObject.routePath + "/complete", query: {dataToken: dataToken}});
                  } else {
                      this.$router.push({name:'TableOrderComplete', query: {dataToken: dataToken}});
                  }
              }
          },
        },
        watch:{

        }
    }
</script>
<style lang="less" scoped src="../../less/order.less"/>
<style lang="less" scoped src="../../less/tableOrder.less"/>